import React from 'react';
import {
    AuthCard,
    FieldGroup,
    InputFull,
    InputCode,
    PWithFontSize,
    ActionsWrapper,
} from './AuthCard';
import { PrimaryButton } from '../../../shared/ui/Inputs';
import { Spinner } from '../../../shared/ui/Spinners';

type Props = {
    email: string;
    verificationCode: string;
    message: string;
    isLogin: boolean;
    onChangeEmail: (v: string) => void;
    onChangeCode: (v: string) => void;
    onSubmit: () => void;
};

export const VerifyEmailCard: React.FC<Props> = ({
    email,
    verificationCode,
    message,
    isLogin,
    onChangeEmail,
    onChangeCode,
    onSubmit,
}) => {
    return (
        <AuthCard
            title="Bem-vindo ao"
            subtitle="Confirmar e-mail de acesso"
            message={message}
        >
            <FieldGroup>
                <InputFull
                    placeholder="E-mail"
                    value={email}
                    onChange={(e) => onChangeEmail(e.target.value)}
                />

                <InputCode>
                    <PWithFontSize fontSize="14px">
                        Você deverá receber um código de confirmação no seu e-mail de
                        cadastro.
                    </PWithFontSize>

                    <InputFull
                        placeholder="Código de confirmação"
                        value={verificationCode}
                        onChange={(e) => onChangeCode(e.target.value)}
                    />
                </InputCode>
            </FieldGroup>

            {isLogin ? (
                <div
                    style={{ marginTop: 12, display: 'flex', justifyContent: 'center' }}
                >
                    <Spinner />
                </div>
            ) : (
                <ActionsWrapper>
                    <PrimaryButton onClick={onSubmit}>Confirmar e-mail</PrimaryButton>
                </ActionsWrapper>
            )}
        </AuthCard>
    );
};
